import React from 'react';
import useGetSouscriptionInformationsQuery from './hooks/useGetSouscriptionInformationsQuery.js';
import SouscriptionInformationsForm from './SouscriptionInformationsForm.jsx';
import { Loading } from '@fasstech/middle-design-system';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';

const SouscriptionInformations = ({ getMiddleText, getMiddleBoolean, phoneIndicatives }) => {
  const { getSouscriptionInformations, loading: isLoadingGetSouscriptionInformations } =
    useGetSouscriptionInformationsQuery();

  if (isLoadingGetSouscriptionInformations) {
    return <Loading />;
  }

  return (
    <SouscriptionInformationsForm
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      data={getSouscriptionInformations}
      phoneIndicatives={phoneIndicatives}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionInformations);
